export enum AppLinks {
    Login = "/auth/login",
    Quotes = "/quotes",
    Capacity = "/tcr/duos",
    Customer = "/tcr/duos/AeZ827nX9B54eJsMF6ApkgM6jqvycprGLg",
    Terms = "/terms"
}

export enum CalendarTypes {
    CalendarRange = "Calendar Range Picker",
    SingleCalendar = " Single Calendar"
}